import { changeStockLocation } from '../slice/product.slice';

export const stockLocationUpdatedEvent = changeStockLocation;
